/**
 * Simple date formatter supporting various date/time patterns
 *
 * Supported patterns:
 * - yyyy/yyy/yy/y: Year (4-digit/4-digit/2-digit/4-digit)
 * - MMMM/MMM/MM/M: Month (full name/short name/2-digit/1-2 digit)
 * - dd/d: Day (2-digit/1-2 digit)
 * - EEEE/EEE/EE/E: Day of week (full/short)
 * - kk/k: 24-hour format (2-digit/1-2 digit)
 * - hh/h: 12-hour format (2-digit/1-2 digit)
 * - mm/m: Minutes (2-digit/1-2 digit)
 * - a: AM/PM marker
 *
 * @example
 * const formatter = new simpleDateFormat('yyyy-MM-dd kk:mm', null);
 * formatter.format(new Date()); // "2025-12-12 08:00"
 */
export function simpleDateFormat(e, t) {
  this.locale = t && (t == "es_US" || t == "en_CA" || t == "fr_CA" || t == "en_GB" || t == "en_AU" || t == "pl_PL" || t == "de_DE") ? t : "en_US";
  this.applyPattern = function (e) {
    this.pattern = e || (this.locale == "en_CA" || this.locale == "fr_CA" || this.locale == "en_GB" || this.locale == "en_AU" ? "d/M/yy" : "M/d/yy")
  };
  this.applyPattern(e);
  this.format = function (e) {
    e = e || new Date;
    if (!(e instanceof Date)) {
      var n = e.split("T")[0].split("-"),
          r = e.split("T").length > 1 ? e.split("T")[1].split(".")[0].split("Z")[0].split("-")[0].split(":") : ["00", "00", "00"];
      e = new Date(n[0], n[1] - 1, n[2], r[0], r[1], r[2])
    }
    var i = function (e) {
      e = "" + e;
      return e.indexOf("0") == 0 && e != "0" ? e.substring(1) : e
    },
    s = function (e) {
      e = Number(e);
      return isNaN(e) ? "00" : (e < 10 ? "0" : "") + e
    },
    o = {
      month: s(e.getMonth() + 1),
      date: s(e.getDate()),
      year: s(e.getFullYear()),
      day: e.getDay(),
      hour24: e.getHours(),
      hour12: e.getHours(),
      minutes: s(e.getMinutes()),
      ampm: "AM"
    };
    if (o.hour24 > 11) {
      o.ampm = "PM"
    }
    o.hour24 = s(o.hour24);
    if (o.hour12 == 0) {
      o.hour12 = 12
    }
    if (o.hour12 > 12) {
      o.hour12 = o.hour12 - 12
    }
    o.hour12 = s(o.hour12);
    var u, a = function (e) {
      var n = e.replace(/yy+(?=y)/g, "yy").replace(/MMM+(?=M)/g, "MMM").replace(/d+(?=d)/g, "d").replace(/EEE+(?=E)/g, "EEE").replace(/a+(?=a)/g, "").replace(/k+(?=k)/g, "k").replace(/h+(?=h)/g, "h").replace(/m+(?=m)/g, "m"),
          r = n.replace(/yyy/g, o.year).replace(/yy/g, o.year.substring(2)).replace(/y/g, o.year).replace(/dd/g, o.date).replace(/d/g, i(o.date)),
          u = function (e, t, n) {
            for (var r = 1; r < e.length; r++) {
              if (!isNaN(e[r].substring(0, 1))) {
                var i = e[r].substring(0, 2);
                e[r] = e[r].substring(2);
                if (isNaN(i.substring(1))) {
                  e[r] = i.substring(1) + e[r];
                  i = i.substring(0, 1)
                }
                i = Number(i);
                if (i > 23) {
                  i = 23
                }
                var u = n == "+" ? i : 0 - i;
                if (t == "kk" || t == "k") {
                  u = Number(o.hour24) + u;
                  if (u > 24) {
                    u = u - 24
                  } else if (u < 0) {
                    u = u + 24
                  }
                } else {
                  u = Number(o.hour12) + u;
                  if (u > 24) {
                    u = u - 24
                  } else if (u < 0) {
                    u = u + 24
                  }
                  if (u > 12) {
                    u = u - 12
                  }
                }
                u = "" + u;
                if (t == "kk" || t == "hh") {
                  u = s(u)
                }
                if (t == "h" && u == 0 || t == "hh" && u == "00") {
                  u = "12"
                }
                e[r] = u + e[r]
              }
            }
            return e.join("")
          };
      if (r.indexOf("k+") != -1) {
        r = u(r.split("kk+"), "kk", "+");
        r = u(r.split("k+"), "k", "+")
      }
      if (r.indexOf("k-") != -1) {
        r = u(r.split("kk-"), "kk", "-");
        r = u(r.split("k-"), "k", "-")
      }
      r = r.replace(/kk/g, o.hour24).replace(/k/g, i(o.hour24));
      if (r.indexOf("h+") != -1) {
        r = u(r.split("hh+"), "hh", "+");
        r = u(r.split("h+"), "h", "+")
      }
      if (r.indexOf("h-") != -1) {
        r = u(r.split("hh-"), "hh", "-");
        r = u(r.split("h-"), "h", "-")
      }
      r = r.replace(/hh/g, o.hour12 < 12 && o.hour12.indexOf && o.hour12.indexOf("0") != 0 ? "0" + o.hour12 : o.hour12).replace(/h/g, i(o.hour12));
      r = r.replace(/mm/g, o.minutes).replace(/m/g, i(o.minutes));
      // Replace AM/PM pattern marker 'a' early, before month/day name substitution
      // Placeholder must not contain uppercase M or E (they are format pattern chars replaced later)
      r = r.replace(/a/g, "___AP___");
      var a = ["January", "February", "march", "april", "may", "June", "July", "august", "September", "October", "November", "December"];
      if (t == "es_US") {
        a = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"]
      }
      if (t == "fr_CA") {
        a = ["janvier", "f&" + "#233;vrier", "mars", "avril", "mai", "juin", "juillet", "ao&" + "#251;t", "septembre", "octobre", "novembre", "d&" + "#233;cembre"]
      }
      if (t == "pl_PL") {
        a = ["styczeń", "luty", "marzec", "kwiecień", "maj", "czerwiec", "lipiec", "sierpień", "wrzesień", "październik", "listopad", "grudzień"]
      }
      if (t == "de_DE") {
        a = ["Januar", "Februar", "märz", "April", "mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"]
      }
      var polishAbbrev = ["sty", "lut", "mar", "kwi", "maj", "cze", "lip", "sie", "wrz", "paź", "lis", "gru"];
      var germanAbbrev = ["Jan", "Feb", "mär", "Apr", "mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"];
      if (t == "pl_PL") {
        r = r.replace(/MMMM/g, a[Number(o.month) - 1]).replace(/MMM/g, polishAbbrev[Number(o.month) - 1]).replace(/MM/g, o.month).replace(/M/g, i(o.month));
      } else if (t == "de_DE") {
        r = r.replace(/MMMM/g, a[Number(o.month) - 1]).replace(/MMM/g, germanAbbrev[Number(o.month) - 1]).replace(/MM/g, o.month).replace(/M/g, i(o.month));
        r = r.replace(/märz/g, "März").replace(/mär/g, "Mär").replace(/mai/g, "Mai");
      } else {
        r = r.replace(/MMMM/g, a[Number(o.month) - 1]).replace(/MMM/g, a[Number(o.month) - 1].substring(0, 3)).replace(/MM/g, o.month).replace(/M/g, i(o.month));
        r = r.replace(/march/g, "March").replace(/mar/g, "Mar").replace(/may/g, "May").replace(/Mayo/g, "mayo");
      }
      var f = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
      if (t == "es_US") {
        f = ["domingo", "lunes", "martes", "mi&" + "eacute;rcoles", "jueves", "viernes", "s&" + "aacute;bado"]
      }
      if (t == "fr_CA") {
        f = ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"]
      }
      if (t == "pl_PL") {
        f = ["niedziela", "poniedziałek", "wtorek", "środa", "czwartek", "piątek", "sobota"]
      }
      if (t == "de_DE") {
        f = ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"]
      }
      r = r.replace(/EEEE/g, f[o.day]).replace(/EEE/g, f[o.day].substring(0, 3)).replace(/EE/g, f[o.day].substring(0, 3)).replace(/E/g, f[o.day].substring(0, 3));
      // Replace AM/PM placeholder with actual value
      r = r.replace(/___AP___/g, o.ampm);
      r = r.replace(/april/g, "April").replace(/apr/g, "Apr").replace(/august/g, "August").replace(/aug/g, "Aug");
      return r
    };
    if (this.pattern.indexOf("'") == -1) {
      u = a(this.pattern)
    } else {
      var f = this.pattern.replace(/\'+(?=\')/g, "''").split("''");
      if (f.length == 1) {
        f = this.pattern.split("'");
        for (var l = 0; l < f.length; l++) {
          if (l % 2 == 0) {
            f[l] = a(f[l])
          }
        }
        return f.join("")
      } else {
        for (var l = 0; l < f.length; l++) {
          var c = f[l].split("'");
          for (var h = 0; h < c.length; h++) {
            if (h % 2 == 0) {
              c[h] = a(c[h])
            }
          }
          f[l] = c.join("")
        }
        return f.join("'")
      }
    }
    return u
  }
}
